import React from "react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section align-content-center justify-content-center">
        <div className="container">
            <div className="col-lg-7 text-white">

              <h1 className="fw-bold display-4">
                Quality Pipes, Motors & Cables <br />
                Built for Strength and Reliability
              </h1>

              <p className="mt-3">
                We supply premium quality pipes, motors, and electrical cables designed
                for durability, efficiency, and long-lasting performance for industrial
                and residential needs.
              </p>

              <div className="d-flex align-items-center gap-4 mt-4">
                <button
                  className="btn btn-light px-4 py-2 rounded-pill"
                  onClick={() => navigate("/contact")}
                >
                  Get Started
                </button>

                <div>
                  <small>Requesting a Call:</small>
                  <div className="fw-bold">+91 9415481386</div>
                </div>
              </div>

            </div>
        </div>
    </section>
  );
};

export default Hero;
